"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusRingTheme = exports.createFocusRingStyles = void 0;
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
/**
 * This file was created to be an easier API than focusRing.ts.
 * It'll do some math so you don't need to.
 *
 * It's split out so we don't have to upgrade the whole repo and can move components over to
 * this one over time.
 */

const focusRingTheme = (0, _sdsThemeInternal.themed)({
  outerColor: (0, _designTokensReact.color)("color--border--surfaces--focus"),
  innerColor: {
    // no equivalent semantic token for this white/transparent mix
    "lodestar-light": "transparent",
    oldestar: "transparent",
    "ursa-light": (0, _designTokensReact.color)("color--border--surfaces--body")
  }
});

// TODO look into outline-color: none and using multiple box-shadows instead of a border color on :before?
exports.focusRingTheme = focusRingTheme;
const createFocusRingStyles = _ref => {
  let {
    colorOverride,
    innerColorOverride,
    theme,
    gap,
    componentBorderWidth,
    componentRadius,
    componentRadiusOverride,
    ringWidth = 2,
    position = "relative",
    pseudoElement = "before",
    focusSelector = ":focus",
    secondaryWidth = 1
  } = _ref;
  // This needs to be a negative number so we'll subtract all of these from 0.
  const borderOffset = `calc(0px - ${px(gap)} - ${px(ringWidth)} - ${px(componentBorderWidth)})`;

  // If this is a string, assume the calculations are already done. Otherwise, calculate the radius.
  const outerBorderRadius = componentRadiusOverride || `calc(${px(componentRadius)} + calc(${px(gap)} + ${px(ringWidth)} ))`;
  return `
        & {
            position: ${position};
            outline: none;
        }

        &${focusSelector} {
            outline: none;
        }

        &${focusSelector}::${pseudoElement} {
            content: "";
            display: block;
            
            position: absolute;
            inset: ${borderOffset};

            border: ${ringWidth}px solid ${colorOverride || focusRingTheme.outerColor(theme)};
            border-radius: ${outerBorderRadius};

            pointer-events: none;

            box-shadow: inset 0 0 0 ${secondaryWidth}px ${innerColorOverride || focusRingTheme.innerColor(theme)};
        }
    `;
};
exports.createFocusRingStyles = createFocusRingStyles;
const px = input => typeof input === "string" ? input : `${input}px`;
//# sourceMappingURL=createFocusRingStyles.js.map